// eslint-disable-next-line no-mixed-operators
export default (originalPrice, discountedPrice) => Math.round((100 * (originalPrice - discountedPrice) / originalPrice) * 10) / 10;
